"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _polished = require("polished");

var _styled = _interopRequireWildcard(require("../styled"));

var _theme = require("../theme");

var _BusyIndicator = _interopRequireDefault(require("./BusyIndicator"));

var _InteractionRipples = _interopRequireDefault(require("./InteractionRipples"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// TODO Possible microinteraction improvement
// There's currently no "exit" aimation, but those are probably rearely needed to not require implementing them
// since a proper implementation would require us to use `react-spring`, and this is such a minor thing that I don't think
// it is required. (Nino)
var appearAnimation = (0, _styled.keyframes)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    width: 0px;\n    margin-right: 0em;\n    transform: scale(0);\n  }\n\n  to {\n    width: 12px;\n    margin-right: 0.5em;\n    transform: scale(1);\n  }\n"])));
var ButtonBusy = (0, _styled["default"])(_BusyIndicator["default"])(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  left: -2px;\n  top: -0.2ex;\n  vertical-align: middle;\n  pointer-events: none;\n  display: inline-block;\n\n  width: 0px;\n  margin-right: 0em;\n  transform: scale(0);\n\n  animation: ", ";\n  animation-duration: 250ms;\n  animation-fill-mode: forwards;\n\n  circle {\n    /* The default colour on the indicator is theme.primary */\n    stroke: currentColor;\n    /* Since it's scaled down the stroke loses visibility, so we make it a bit thiccer */\n    stroke-width: 15;\n  }\n"])), appearAnimation);

function variantStyles(variant) {
  switch (variant) {
    case 'primary':
      return (0, _styled.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        background-color: ", ";\n        padding: 1.25ex 1em;\n        border: none;\n        color: ", ";\n\n        @media (hover: hover) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      "])), function (props) {
        return props.theme.primary;
      }, function (props) {
        return (0, _theme.computeContrastingColor)(props.theme.primary);
      }, function (props) {
        return (0, _polished.mix)(0.1, (0, _theme.computeContrastingColor)(props.theme.primary), props.theme.primary);
      });

    case 'secondary': // Secondary variant is the default (for now?)

    default:
      return (0, _styled.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        background-color: transparent;\n        padding: calc(1.25ex - 1px) calc(1em - 1px);\n        border: 1px solid ", ";\n        color: ", ";\n\n        @media (hover: hover) {\n          &:hover {\n            background-color: ", ";\n          }\n        }\n      "])), function (props) {
        return props.theme.primary;
      }, function (props) {
        return props.theme.primary;
      }, function (props) {
        return (0, _polished.transparentize)(0.9, props.theme.primary);
      });
  }
}

var ButtonWrapper = _styled["default"].button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  font-family: ", ";\n  box-sizing: border-box;\n  font-size: 75%;\n  font-weight: 600;\n  text-transform: uppercase;\n  background-color: transparent;\n  border-radius: 4px;\n  overflow: hidden;\n  outline: none;\n\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n\n  /* Variant styling */\n  ", "\n\n  box-shadow: ", ";\n\n  /* Disabled */\n  ", "\n\n  /* Remove ugly outline in Mozilla */\n  &:-moz-focusring {\n    outline: none;\n  }\n"])), function (props) {
  return props.theme.fonts.button;
}, function (props) {
  return variantStyles(props.variant);
}, function (props) {
  return props.theme.shadows[props.elevation];
}, function (props) {
  return props.disabled && (0, _styled.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: ", ";\n      pointer-events: none;\n      color: ", ";\n    "])), props.theme.disabled, props.theme.disabled, (0, _theme.computeContrastingColor)(props.theme.disabled));
});
/**
 * Represents an action, or a request for an action.
 * Apart from the props outlined here, it also accepts all the props a `<button>` element accepts, too (`onClick`, etc).
 */


var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      busy = _ref.busy,
      children = _ref.children,
      _ref$elevation = _ref.elevation,
      elevation = _ref$elevation === void 0 ? 0 : _ref$elevation,
      rest = _objectWithoutProperties(_ref, ["disabled", "busy", "children", "elevation"]);

  return /*#__PURE__*/React.createElement(ButtonWrapper, _extends({}, rest, {
    elevation: elevation,
    ref: ref,
    tabIndex: -1,
    disabled: disabled
  }), /*#__PURE__*/React.createElement(_InteractionRipples["default"], {
    focusable: true,
    disabled: disabled
  }), busy && /*#__PURE__*/React.createElement(ButtonBusy, null), children);
});
var _default = Button;
exports["default"] = _default;